import { gql } from 'graphql-tag'

export const GET_SETTINGS = gql`
  query getSettings($organizationId: String!, $slug: String!) {
    settingsBySlug(organizationId: $organizationId, slug: $slug) {
      organizationId
      colorPrimary
      colorSecondary
      colorHotelMarkerPrimary
      colorHotelMarkerSecondary
      hideHotline
      hideAddressAutocompleteInput
      name
      slug
      colorPrimary
      colorSecondary
      colorHotelMarkerPrimary
      colorHotelMarkerSecondary
    }
  }
`
